export default "__VITE_ASSET__ZoP2ebLT5e$hm8jPkF9mgA__ 480w, __VITE_ASSET__cLZLOsSELI_GmwKcVOKKRw__ 680w";